(() => {
  const storageKey = 'mishop_purchase_mode_v1';
  const storageAtKey = 'mishop_purchase_mode_v1_at';
  const retentionMs = 60 * 24 * 60 * 60 * 1000;
  const root = document.querySelector('[data-mishop-reventa]');
  if (!root) return;

  const safeRead = () => {
    try {
      const storedAt = Number(localStorage.getItem(storageAtKey) || 0);
      if (!storedAt || Date.now() - storedAt > retentionMs) {
        localStorage.removeItem(storageKey);
        localStorage.removeItem(storageAtKey);
        return 'personal';
      }
      return localStorage.getItem(storageKey) === 'reventa' ? 'reventa' : 'personal';
    }
    catch (_) { return 'personal'; }
  };
  const safeWrite = value => {
    try {
      localStorage.setItem(storageKey, value);
      localStorage.setItem(storageAtKey, String(Date.now()));
    } catch (_) {}
  };
  const emit = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
  };
  const apply = (mode, source = 'stored') => {
    document.body.dataset.mishopMode = mode;
    root.hidden = false;
    root.querySelectorAll('[data-reventa-choice]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.reventaChoice === mode));
    });
    const business = root.querySelector('[data-reventa-business]');
    if (business) business.hidden = mode !== 'reventa';
    document.querySelectorAll('[data-mishop-cross-sell] [data-relation]').forEach(card => {
      const relation = card.dataset.relation;
      card.style.order = mode === 'reventa' && relation === 'UPGRADE' ? '-1' : '0';
    });
    document.querySelectorAll('a[href*="wa.me"]').forEach(link => {
      if (mode !== 'reventa' || link.dataset.mishopReventaApplied === 'true') return;
      try {
        const url = new URL(link.href);
        const text = url.searchParams.get('text') || '';
        url.searchParams.set('text', `${text}${text ? '\n\n' : ''}Modo de compra: para revender.`);
        link.href = url.toString();
        link.dataset.mishopReventaApplied = 'true';
      } catch (_) {}
    });
    if (source !== 'stored') emit('mishop_reventa_mode_change', { mode, source_page: location.pathname, source });
  };

  root.addEventListener('click', event => {
    const button = event.target.closest('[data-reventa-choice]');
    if (!button) return;
    const mode = button.dataset.reventaChoice;
    safeWrite(mode);
    apply(mode, 'selector');
  });
  apply(safeRead());

  let cartContents = [];
  const cartContext = document.querySelector('[data-mishop-cart-context]');
  if (cartContext) {
    try { cartContents = JSON.parse(cartContext.textContent); } catch (_) {}
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mishop-wholesale-source], [data-mishop-wholesale-ai], [data-mishop-event*="wholesale"]');
    if (!trigger) return;
    const context = trigger.closest('[data-mishop-wholesale-cta]') || trigger;
    emit('mishop_wholesale_lead_intent', {
      schema_version: 1,
      timestamp: new Date().toISOString(),
      source_page: location.pathname,
      source: context.dataset.mishopWholesaleSource || trigger.dataset.mishopSource || 'mayoreo_cta',
      channel: trigger.matches('a[href*="wa.me"]') ? 'whatsapp' : trigger.hasAttribute('data-mishop-wholesale-ai') ? 'ai' : 'mayoreo',
      product: context.dataset.productTitle || '',
      sku: context.dataset.productSku || '',
      variant: context.dataset.productVariantId || '',
      quantity: Number(context.dataset.quantity || 0),
      cart_contents: cartContents,
      reventa_mode: document.body.dataset.mishopMode === 'reventa'
    });
  });
})();
